/* Linen: founder video. The card opens the sheet through linen-base.js ([data-linen-open]);
   this loads the film only when the sheet opens, plays it, and pauses + rewinds it on close
   (close button, backdrop, Esc, or the theme editor unloading the section). */
if (!customElements.get('linen-founder-video')) {
  customElements.define(
    'linen-founder-video',
    class extends HTMLElement {
      connectedCallback() {
        this.modal = this.querySelector('.linen-modal');
        this.video = this.querySelector('video');
        this.onModal = (e) => {
          const video = this.video;
          if (!video || !e.detail || e.detail.modal !== this.modal) return;
          if (e.type === 'linen:modal:open') {
            if (!video.getAttribute('src')) {
              video.poster = video.dataset.poster || '';
              video.src = video.dataset.src;
            }
            // Runs inside the tap that opened the sheet, so phones allow playback with sound.
            const playing = video.play();
            if (playing) playing.catch(() => {});
          } else {
            video.pause();
            video.currentTime = 0;
          }
        };
        document.addEventListener('linen:modal:open', this.onModal);
        document.addEventListener('linen:modal:close', this.onModal);
      }

      disconnectedCallback() {
        document.removeEventListener('linen:modal:open', this.onModal);
        document.removeEventListener('linen:modal:close', this.onModal);
      }
    }
  );
}
